export default {
    data: [
        { id: 1, name: "20250501", label: "2025年5月《法律法规》模考真题一" },
        { id: 2, name: "20250502", label: "2025年5月《基金基础》模考真题一" },
        { id: 3, name: "2024501", label: "2024年5月《法律法规》模考真题一" },
        { id: 4, name: "2024502", label: "2024年5月《法律法规》模考真题二" },
        { id: 5, name: "2024503", label: "2024年5月《法律法规》模考真题三" },
        { id: 6, name: "2024504", label: "2024年5月《法律法规》模考真题四" },
        { id: 7, name: "2024505", label: "2024年5月《法律法规》模考真题五" },
        { id: 8, name: "2024506", label: "2024年5月《法律法规》模考真题六" },
        { id: 9, name: "2024507", label: "2024年5月《基金基础》模考真题一" },
        { id: 10, name: "2024508", label: "2024年5月《基金基础》模考真题二" },
        { id: 11, name: "2024509", label: "2024年5月《基金基础》模考真题三" },
        { id: 12, name: "2024510", label: "2024年5月《基金基础》模考真题四" },
        { id: 13, name: "2024511", label: "2024年5月《基金基础》模考真题五" },
        { id: 14, name: "2024512", label: "2024年5月《基金基础》模考真题六" },
        { id: 15, name: "2024513", label: "2024年5月《私募股权》模考真题一" },
        { id: 16, name: "2024514", label: "2024年5月《私募股权》模考真题二" },
        { id: 17, name: "2024515", label: "2024年5月《私募股权》模考真题三" },
        { id: 18, name: "2024516", label: "2024年5月《私募股权》模考真题四" },
        { id: 19, name: "2024517", label: "2024年5月《私募股权》模考真题五" },
        { id: 20, name: "2024518", label: "2024年5月《私募股权》模考真题六" },
        { id: 21, name: "2024519", label: "2024年11月《法律法规》模考真题一" },
        { id: 22, name: "2024520", label: "2024年11月《法律法规》模考真题二" },
        { id: 23, name: "2024521", label: "2024年11月《法律法规》模考真题三" },
        { id: 24, name: "2024522", label: "2024年11月《法律法规》模考真题四" },
        { id: 25, name: "2024523", label: "2024年11月《基金基础》模考真题一" },
        { id: 26, name: "2024524", label: "2024年11月《基金基础》模考真题二" },
        { id: 27, name: "2024525", label: "2024年11月《基金基础》模考真题三" },
        { id: 28, name: "2024526", label: "2024年11月《基金基础》模考真题四" },
        { id: 29, name: "2024527", label: "2024年11月《私募股权》模考真题一" },
        { id: 30, name: "2024528", label: "2024年11月《私募股权》模考真题二" },
        { id: 31, name: "2024529", label: "2024年11月《私募股权》模考真题三" },
        { id: 32, name: "2024530", label: "2024年11月《私募股权》模考真题四" },
        { id: 33, name: "20210101", label: "2021年《法律法规》模考真题一" },
        { id: 34, name: "20210102", label: "2021年《法律法规》模考真题二" },
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/menu.js